// modules
import React, {FC} from "react";
// types
import {SvgTypes} from "../../types/SvgType";

const GitHub: FC<SvgTypes> = (props) => {
    const {width, height, className} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 56 56"
            className={className}
        >
            <g clipPath="url(#clip0_8_72)">
                <path
                    fill="#B0B2C3"
                    d="M51.92 14.869c-2.458-4.213-5.794-7.55-10.007-10.008-4.214-2.459-8.814-3.688-13.804-3.688-4.989 0-9.59 1.23-13.803 3.688-4.213 2.459-7.549 5.795-10.008 10.008C1.84 19.082.61 23.683.61 28.672c0 5.992 1.748 11.38 5.246 16.166 3.497 4.786 8.014 8.098 13.552 9.936.645.12 1.122.036 1.432-.25a1.4 1.4 0 00.466-1.074l-.018-1.933c-.013-1.218-.018-2.28-.018-3.187l-.824.143c-.525.096-1.188.137-1.987.125-.8-.01-1.63-.095-2.489-.25a5.558 5.558 0 01-2.399-1.074 4.543 4.543 0 01-1.575-2.202l-.358-.824c-.239-.548-.615-1.157-1.128-1.825-.513-.669-1.032-1.122-1.558-1.36l-.25-.18a2.634 2.634 0 01-.465-.43 1.963 1.963 0 01-.323-.502c-.071-.167-.012-.304.18-.412.19-.108.536-.16 1.038-.16l.716.107c.477.096 1.068.381 1.772.859a5.78 5.78 0 011.737 1.861c.549.98 1.21 1.725 1.987 2.239.775.513 1.558.77 2.345.77.788 0 1.468-.06 2.041-.18a7.112 7.112 0 001.611-.536c.215-1.6.8-2.83 1.755-3.689-1.36-.143-2.584-.358-3.67-.644-1.086-.287-2.208-.752-3.366-1.397s-2.119-1.445-2.883-2.4c-.763-.954-1.39-2.208-1.88-3.76-.488-1.55-.733-3.341-.733-5.37 0-2.889.943-5.347 2.829-7.376-.884-2.172-.8-4.607.25-7.304.693-.216 1.72-.054 3.08.483s2.357.997 2.99 1.379c.632.38 1.14.704 1.521.966 2.221-.62 4.512-.93 6.876-.93 2.363 0 4.654.31 6.875.93l1.36-.859c.931-.573 2.03-1.098 3.294-1.575 1.266-.478 2.233-.61 2.902-.394 1.073 2.697 1.17 5.132.286 7.304 1.885 2.03 2.829 4.488 2.829 7.376 0 2.03-.246 3.825-.734 5.389-.49 1.564-1.122 2.816-1.897 3.76-.777.943-1.743 1.737-2.901 2.38-1.158.645-2.28 1.11-3.366 1.397-1.087.287-2.31.502-3.67.646 1.24 1.074 1.861 2.769 1.861 5.084v7.554c0 .43.15.788.448 1.074.299.286.77.37 1.414.25 5.539-1.837 10.056-5.15 13.553-9.936 3.497-4.785 5.246-10.174 5.246-16.166-.001-4.988-1.231-9.589-3.689-13.802z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_8_72">
                    <path
                        fill="#fff"
                        d="M0 0H55V55H0z"
                        transform="translate(.61 .5)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export default GitHub;

GitHub.defaultProps = {
    width: 58,
    height: 58,
}
